import {CommonResponse, BaseRequestParams, GetParamsType, instance} from "./API"
import {AxiosResponse} from "axios"
import {filterToString} from "../helps/filterToString"
import {NotificationResponse} from "../models/response"

export const notificationApi = {
    getNotifications(params?: GetParamsType): Promise<CommonResponse<NotificationsResponse>> {
        const paramsString = filterToString(params)
        return instance.get(`notification/${paramsString}`, {signal: params?.controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    setViewed(params: SetViewed): Promise<CommonResponse<number>> {
        const {id = 0, controller} = params
        return instance.delete(`notification/${id}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
}

export type NotificationsResponse = {
    data: Array<NotificationResponse>
    total: number
}

export type SetViewed = {
    id?: number
} & BaseRequestParams
